import React, { useState, useEffect } from 'react';
import images from '../images';
import styles from '../css/ItemCarrito.module.scss'
import { FormInput } from './FormInput';
import { useContextoGlobal } from '../ContextoGlobal';

export const ItemCarrito = ({ imagen, nombre, url, id, idObjeto, precio, precioOferta, precioRegular, on_sale, cantidad }) => {
    const { removerItemCarrito, cambiarCantidadItem } = useContextoGlobal();
    const [cantProd, setCantProd] = useState(cantidad);
    useEffect(() => {
        if (cantProd !== cantidad)
            setCantProd(cantidad)
    }, [cantidad])

    useEffect(() => {
        if (cantProd !== cantidad)
            cambiarCantidadItem(id, Number(cantProd))
    }, [cantProd])

    return (

        <div id={idObjeto} className={styles.producto + ' mx-3 row border-bottom '}>
            <div className={styles.contImagen + ' col-2 align-self-center'}>
                <a href={url} className={'text-decoration-none text-black '}>
                    <img src={imagen} className={styles.imagen} />
                </a>
            </div>
            <div className={styles.contDescripcion + ' col'}>
                <div className='row'>
                    <p className={styles.nombre + ' mb-2 col'}>
                        <a href={url} className={'text-decoration-none text-black '}>
                            {nombre}
                        </a>
                    </p>
                    <div className='col-2 w-auto'>
                        <img src={images.icons.eliminar} alt="" className={styles.imgBtn} onClick={() => removerItemCarrito(id)} />
                    </div>
                </div>
                <div className={'row mt-3 align-items-end ' + styles.rowPrecios}>
                    <div className='col-4'>
                        <FormInput id={'cant-' + idObjeto} type={'number'} value={cantProd} setValue={setCantProd} />
                    </div>
                    <div className='col text-end'>
                        {on_sale ? <p className={styles.precio}>{'$' + precioRegular * cantidad}</p> : <></>}
                        <p className={styles.precioOferta}>{'$' + precio * cantidad}</p>

                    </div>

                </div>
            </div>
        </div>
    )

}
